/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_LedeInputs */

const tr_landing_shortcuts_lede = /** @type {(inputs: Landing_Shortcuts_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`⌘K ile her şeye anında ulaşın: siparişler, ürünler, müşteriler, ayarlar, mağazalar. Çoklu panel araması: 14 mağaza arasında tek sorgu. Depolama ihtiyacı büyüdükçe buluttaki alanı istediğiniz kadar genişletin.`)
};

const en_landing_shortcuts_lede = /** @type {(inputs: Landing_Shortcuts_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reach anything instantly with ⌘K: orders, products, customers, settings, stores. Multi-panel search: one query across 14 stores. As your storage needs grow, expand your cloud space as much as you like.`)
};

const de_landing_shortcuts_lede = /** @type {(inputs: Landing_Shortcuts_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit ⌘K erreichen Sie alles sofort: Bestellungen, Produkte, Kunden, Einstellungen, Shops. Suche über mehrere Panels: eine Abfrage über 14 Shops. Wächst Ihr Speicherbedarf, erweitern Sie den Cloud-Speicher beliebig.`)
};

const ru_landing_shortcuts_lede = /** @type {(inputs: Landing_Shortcuts_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С ⌘K всё мгновенно под рукой: заказы, товары, клиенты, настройки, магазины. Поиск по нескольким панелям: один запрос по 14 магазинам. Когда объём данных растёт, расширяйте облачное хранилище настолько, насколько нужно.`)
};

/**
* | output |
* | --- |
* | "Reach anything instantly with ⌘K: orders, products, customers, settings, stores. Multi-panel search: one query across 14 stores. As your storage needs grow, ..." |
*
* @param {Landing_Shortcuts_LedeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_lede = /** @type {((inputs?: Landing_Shortcuts_LedeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_LedeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_lede(inputs)
	if (locale === "de") return de_landing_shortcuts_lede(inputs)
	if (locale === "ru") return ru_landing_shortcuts_lede(inputs)
	return tr_landing_shortcuts_lede(inputs)
});